// extracted by mini-css-extract-plugin
export default {"container":"List_container__Lx5Jh","row":"List_row__UAQTs","column":"List_column__lMnWZ","title":"List_title__wXJtN"};